<template>
  <div class="approved-approval">
    <div class="text-right">
      <a-button slot="extra" @click="goBack">返回</a-button>
    </div>
    <!-- 审批流程 -->
    <a-card title="审批流程" :loading="loading" class="card">
      <process :process-list="process" />
    </a-card>
    <!--基本信息-->
    <a-card title="基本信息">
      <a-row>
        <a-col :span="8">企业ID: {{ baseInfo.childCode }}</a-col>
        <a-col :span="8">企业名称: {{ baseInfo.childName }}</a-col>
        <a-col :span="8">关联类型: {{ baseInfo.relationTypeStr }}</a-col>

        <a-skeleton :loading="loading">
          <h3 class="margin-top-40">子公司账期</h3>
          <table-view
            id="mod4"
            :columns="segments"
            :data="detail"
            :pagination="pagination"
          ></table-view>
        </a-skeleton>
      </a-row>
    </a-card>
    <!--申请信息-->
    <a-card style="margin-top:20px;" title="申请信息">
      <a-row :gutter="{ xs: 8, sm: 16, md: 24 }">
        <a-col :lg="8" :md="12" :sm="24" style="margin:10px 0;">
          母公司ID: {{ baseInfo.parentCode }}
        </a-col>
        <a-col :lg="8" :md="12" :sm="24" style="margin:10px 0;">
          母公司名称: {{ baseInfo.parentName }}
        </a-col>
        <a-col :lg="8" :md="12" :sm="24" style="margin:10px 0;">
          母公司是否上市: {{ baseInfo.listedStatusStr }}
        </a-col>
        <a-col :lg="8" :md="12" :sm="24" style="margin:10px 0;">
          关联理由: {{ baseInfo.relationReasonStr }}
        </a-col>
        <a-col :lg="8" :md="12" :sm="24" style="margin:10px 0;">
          所属集团名称: {{ baseInfo.groupName }}
        </a-col>
      </a-row>

      <a-skeleton :loading="loading">
        <h3 class="margin-top-40">母公司账期</h3>
        <table-view
          id="mod4"
          :columns="segments"
          :data="segmentData"
          :pagination="pagination"
        ></table-view>
      </a-skeleton>

      <!-- 申请原因及备注 -->
      <apply-reason-remark :content="remark || ''" :attachments="attachments" />
    </a-card>
    <!-- 审批意见 -->
    <a-card
      title="审批意见"
      class="card"
      :loading="loading"
      style="margin-top:20px;"
      v-if="status == 1 || (status == 2 && show === 1)"
    >
      <quill-editor
        :token="token"
        ref="quillEditor"
        v-if="show === 0"
      ></quill-editor>
      <Approval-reason-remark :content="remarktwo || ''" v-if="show === 1" />
    </a-card>

    <footer-tool-bar v-if="status == 1">
      <a-button
        type="primary"
        class="margin-right-20"
        @click="handleSubmit(APPROVAL_ACTION_OBJ.PASS)"
        :loading="loading"
      >
        审批通过
      </a-button>
      <a-button
        type="danger"
        class="margin-right-20"
        @click="handleSubmit(APPROVAL_ACTION_OBJ.REJECT)"
        :loading="loading"
      >
        审批不通过
      </a-button>
    </footer-tool-bar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  getApplyList,
  doApprove,
  selectTemporaryRelationList,
  searchTerm,
  getPeriodists,
} from './api'
import Process from '../../credit-approval/components/Process.vue'
import { APPROVAL_ACTION_OBJ } from './const'
import ApplyReasonRemark from './ApplyReasonRemarkView.vue'
import ApprovalReasonRemark from './ApprovalReasonRemarkView.vue'
import FooterToolBar from 'components/FooterToolBar.vue'
import QuillEditor from '../../credit-approval/components/QuillEditor.vue'
import { segments } from './schema.js'
import { TableView } from 'lxfintech-fe'
export default {
  data() {
    //这里存放数据
    return {
      baseInfo: {},
      loading: false,
      process: [],
      companyCode: '',
      status: '',
      remarktwo: '',
      remark: '',
      show: 0,
      bpmId: '',
      APPROVAL_ACTION_OBJ,
      attachments: [],
      skeletonLoding: true,
      detail: {},
      companyTermCode: '',
      typeOperate: 1,
      segments,
      segmentData: [],
      pagination: false,
      termList: [],
    }
  },
  components: {
    QuillEditor,
    FooterToolBar,
    Process,
    ApplyReasonRemark,
    ApprovalReasonRemark,
    TableView,
  },
  computed: {
    ...mapGetters('user', ['token']),
  },
  //方法集合
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    async handleSubmit(ack) {
      this.loading = true
      try {
        if (ack == APPROVAL_ACTION_OBJ.REJECT) {
          const query = {
            ack,
            bpmId: this.bpmId,
            remark: this.$refs.quillEditor.getContent(),
          }
          const { code, message } = await doApprove(query)
          if (code === '0000') {
            this.$message.success(message)
            this.$router.push({
              name: 'group-relationship-mana',
            })
          }
        } else {
          const query = {
            ack,
            bpmId: this.bpmId,
            remark: this.$refs.quillEditor.getContent(),
          }
          if(this.detail.length > 0 ){
            for(let i = 0; i < this.detail.length; i++) {
              this.termList.push(this.detail[i].term)
            }
          } 
          //判断是否为标准账期
          const periodData = {
            termList: this.termList,
          }
          const { data } = await getPeriodists(periodData)
          this.periodBo = data.aboolean
          //为标准账期
          if (this.periodBo == true) {
            this.approve(query)
          }else if (this.periodBo == false) {
            //非标准账期
            this.$confirm({
              title: '提示',
              content: '该账期非标准账期，是否继续?',
              okButtonProps: {
                loadings: this.loadings,
              },
              cancelText: '否',
              okText: '是',
              onOk: () => {
                this.loadings = true
                this.approve(query)
              },
              onCancel: () => {
                this.loading = false
              }
            })
          }
          
        }
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    async approve(query){
      const { code, message } = await doApprove(query)
      if (code === '0000') {
        this.$message.success(message)
        this.$router.push({
          name: 'group-relationship-mana',
        })
      }
    },

    async _getApplyList(bpmId) {
      const { data } = await getApplyList(bpmId)
      this.process = data.process
      this.baseInfo = data.companyRelation
      this.attachments = data.attachments
      this.remark = data.relationBpm.remark
      this.show = data.process[1].status
      this.remarktwo = data.process[1].assigners[0].remark

      this.getTerm(this.baseInfo.parentCode)
    },

    //母公司账期
    async getTerm(code) {
      if (!code.trim()) {
        return
      }
      try {
        const { data } = await searchTerm(code)
        this.segmentData = data
      } catch (error) {
        console.error(error)
      }
    },
    //子公司账期详情
    _companyTermDetail(bpmId) {
      console.log(bpmId)
      selectTemporaryRelationList(bpmId).then(({ data }) => {
        this.detail = data
        this.skeletonLoding = false
      })
    },
  },

  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.status = this.$route.query.status
    this.bpmId = this.$route.params.id
    this._getApplyList(this.bpmId)
    this._companyTermDetail(this.bpmId)
  },
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
